import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  username: Yup.string().required("Mobile is required"),
  password: Yup.string()
    .min(8, "Password must be 3 characters at minimum")
    .required("Password is required"),
});
